const isUrlFriendlySEO = urlString => {
  return urlString != "" ? /^[a-zก-๛0-9-]*$/.test(urlString) : true;
};

export default isUrlFriendlySEO;
